import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InMemoryCompanyInfo } from '../models/in-memory-company-info';
import { Company } from '../models/company';
import { CompanyWorkingHours } from '../models/company-working-hours';


@Injectable()
export class CompanyInfoInMemoryService {

  private _inMemoryCompanyInfo = new InMemoryCompanyInfo();

  constructor() { }

  getCompanyInfo(): Observable<Company> {
    return of(this._inMemoryCompanyInfo.items[0]);
  }

  getSchedule(): Observable<CompanyWorkingHours[]> {
    return of(this._inMemoryCompanyInfo.CompanyOpenHours);
  }

  getTodayWorkingHours(): Observable<CompanyWorkingHours> {
    return of(this._inMemoryCompanyInfo.CompanyTodayWorkingHours);
  }
}
